import config from "config";
import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";
import {
    BulkCustomerCicReportingDetail,
    BulkCustomerCicReportingDownloadFileType,
    BulkCustomerCicReportingFileCheckerRemarkType,
    BulkCustomerCicReportingFileMakerRemarkType,
    BulkCustomerCicReportingVersionType,
    uploadBulkCustomerCicReportingFile
} from "./types";

const api = new APICore();

const bulkCicBase = `${config.BACKEND_BASE_URL}/bulk-file/cic_reporting`;
const commonBulkBase = `${config.BACKEND_BASE_URL}/bulk-file`;
function uploadBulkCustomerCicReportingFileApi(params: uploadBulkCustomerCicReportingFile) {
    const formData = new FormData();
    formData.append("file", params.bulkCustomerCicReportingFile);
    return api.create(`${bulkCicBase}`, formData);
}

function fetchBulkCustomerCicReportingApi(params: FilterMetadata) {
    return api.get(`${bulkCicBase}`, params);
}

function fetchBulkCustomerCicReportingDetailApi(params: BulkCustomerCicReportingDetail) {
    return api.get(`${bulkCicBase}/${params.externalID}`, null);
}

function fetchBulkCustomerCicReportingVersionApi(params: BulkCustomerCicReportingVersionType) {
    const baseUrl = `${commonBulkBase}/${params.id}/versions`;
    return api.get(`${baseUrl}`, params.filter);
}

function BulkCustomerCicReportingPublishApi(params: BulkCustomerCicReportingFileMakerRemarkType) {
    const baseUrl = `${commonBulkBase}/${params.externalId}/publish`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function downloadBulkCustomerCicReportingFileApi(params: BulkCustomerCicReportingDownloadFileType) {
    const baseUrl = `${config.BACKEND_BASE_URL}${params.downloadURL}`;
    return api.getFile(`${baseUrl}`, null);
}

function approveBulkCustomerCicReportingFileApi(params: BulkCustomerCicReportingFileCheckerRemarkType) {
    const baseUrl = `${commonBulkBase}/${params.externalId}/approve`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function rejectBulkCustomerCicReportingFileApi(params: BulkCustomerCicReportingFileCheckerRemarkType) {
    const baseUrl = `${commonBulkBase}/${params.externalId}/reject`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function fetchBulkFileSpecificCustomerCicReportingApi(params: BulkCustomerCicReportingVersionType) {
    const baseUrl = `${bulkCicBase}/${params.id}/filerecords`;
    return api.get(`${baseUrl}`, params.filter);
}

function deleteBulkCustomerCicReportingFileApi(params: BulkCustomerCicReportingDetail) {
    const baseUrl = `${commonBulkBase}/${params.externalID}`;
    return api.delete(`${baseUrl}`);
}

export {
    uploadBulkCustomerCicReportingFileApi,
    fetchBulkCustomerCicReportingApi,
    fetchBulkCustomerCicReportingDetailApi,
    fetchBulkCustomerCicReportingVersionApi,
    BulkCustomerCicReportingPublishApi,
    downloadBulkCustomerCicReportingFileApi,
    approveBulkCustomerCicReportingFileApi,
    rejectBulkCustomerCicReportingFileApi,
    fetchBulkFileSpecificCustomerCicReportingApi,
    deleteBulkCustomerCicReportingFileApi
};
